import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import moment from 'moment';

import { SNACKBAR_NAMES } from './snackbar.constants';

export const { Types: SnackbarTypes, Creators: SnackbarActions } = createActions(
  {
    showSnackbar: ['name', 'timeout'],
    hideSnackbar: [],
  },
  { prefix: 'SNACKBAR_' }
);

export const INITIAL_STATE = Immutable({
  activeSnackbar: null,
  endTimestamp: 0,
});

const handleShowSnackbar = (state, { name = null, timeout = 5000 }) => {
  if (SNACKBAR_NAMES.includes(name)) {
    return state.set('activeSnackbar', name).set(
      'endTimestamp',
      moment()
        .add(timeout, 'ms')
        .unix()
    );
  }

  return state;
};

const handleHideSnackbar = state => state.set('activeSnackbar', null);

export const reducer = createReducer(INITIAL_STATE, {
  [SnackbarTypes.SHOW_SNACKBAR]: handleShowSnackbar,
  [SnackbarTypes.HIDE_SNACKBAR]: handleHideSnackbar,
});
